import { render, staticRenderFns } from "./ScannerAddMenu.vue?vue&type=template&id=3aefc4a2"
import script from "./ScannerAddMenu.vue?vue&type=script&lang=js"
export * from "./ScannerAddMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports